// Packages
import { Component, createRef } from "react";
import { Redirect, withRouter } from "react-router-dom";
import axios from "axios";
import { ProgressBar } from "react-bootstrap";
import { CircularProgress } from "@material-ui/core";
// Styles
import "bootstrap/dist/css/bootstrap.min.css";
//datepicekr
import convertSize from "convert-size";
// views
import SchoolAdminDashboard from "./schoolAdminDashboard";
// Assets
import videoCamera from "../../assets/images/videosUpload.svg";
import upArrow from "../../assets/images/up-arrow.png";
import preview from "../../assets/images/Preview.svg";
import successIcon from "../../assets/images/Success.svg";
import updownload from "../../assets/images/whiteUpArrow.png";
// material Ui
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
// Services
import userService from "../../services/user.service";
// Utils
import { getFromLocalStorage } from "../../utils/webStorage";
// common-phone number and email
import { emailAddress, phoneNumber } from "../../common";
import { BsXLg } from "react-icons/bs";
import { FaTrash, FaTimes } from "react-icons/fa";
import { Form, Formik } from "formik";
import UploadVideoForm from "./Upload Video/UploadVideoForm";
import validationSchema from "../../Validation/ValidationSchemas";
import { connect } from "react-redux";
import AddIcon from "@material-ui/icons/Add";
import {
  resetUploadVideoInitialState,
  setUploadedVideoList,
} from "../../Redux/Actions/UploadVideoAction";
import {
  openConfirmationPopup,
  openFailDialog,
  openRenamePopup,
  openSuccessPopup,
  openVideoPopup,
} from "../../Redux/Actions/PopupActions";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import instance from "../../../src/services/api";

import { resetVideoScheduleEventData } from "../../Redux/Actions/VideoScheduleAction";
class uploadVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      fileAddress: null,
      uploadingFileLength: [],
      UploadedData: [],
      percentage: 0,
      filename: [],
      selectedFileData: [],
      open: false,
      opensaveDialog: false,
      isShareData: false,
      isFileUploading: false,
      show: false,
      removeDialog: false,
      sharevideo: false,
      isSelectedVideo: false,
      eventSuccesspopup: false,
      eventName: "",
      eventType: "",
      eventId: "",
      videoName: "",
      submitting: false,
      teamsDropdownData: [],
      schoolId: null,
      category: "",
      fileStatus: [],
      fields: {},
      errors: {},
      dragging: false,
      saveDisable: false,
      open: false,
      uploadVideoCountToShow: null,
      startDate: new Date(),
      disableFlagEvent: false,
      allPlaylistData: [],
      currentLoggedId: "",
      uploadedVideoData: [],
      newAddedFiles: [],
      redirect: false,
      deletePopUp: false,
      currentUserId: "",
      schoolList: [],
      showFlag: false,
      UploadedVideoKeys: [],
      popupMessage: "",
      authorization: "",
      mediaFileArr: [],
      playlistId: null,
      isSelected: true,
      ischecked: false,
      fileSize: "",
      videoDuration: "",
      setTime: new Date(),
      uploaded: false,
      assignedRights: [],
      adminRole: "",
      redirectToVideoEdits: false,
      uploadPercentage: null,
      videoData: "",
      successPopUp: false,
      hideSelectedFiles: false,
      confirmationPopup: false,
      selectedFileKey: "",
      selectedFileIndex: "",
      seasonId: this.props.currentSeason?.years,
      scheduleEventType: "",
      offSeasonEventName: "",
      practiceName: "",
      otherEventType: "",
      weekName: "",
      eventCategory: "",
      loading: false,
    };
    this.changeHandlerForVideoUpload =
      this.changeHandlerForVideoUpload.bind(this);
    this.changeHandlerForVideoUploadAdd =
      this.changeHandlerForVideoUploadAdd.bind(this);
    this.handleSubmissionForVideoUpload =
      this.handleSubmissionForVideoUpload.bind(this);
    this.dropRef = createRef();
  }

  closesharevideoDialog() {
    this.setState({ sharevideo: !this.state.sharevideo });
  }

  opensharevideoDialog() {
    this.setState({ sharevideo: !this.state.sharevideo });
  }

  openDialog() {
    this.setState({ open: !this.state.open });
  }

  closeDialog() {
    this.setState({ open: !this.state.open });
  }

  handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ dragging: true });
    }
  };

  handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter > 0) return;
    this.setState({ dragging: false });
  };

  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ drag: false });
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const fileList = e.dataTransfer.files;
      this.changeHandlerForVideoUpload(fileList, true);
      e.dataTransfer.clearData();
      this.dragCounter = 0;
    }
  };

  componentDidMount() {
    const currentUserId = getFromLocalStorage("currentUserId");
    const currentSchool = getFromLocalStorage("schoolName");
    const schoolId = getFromLocalStorage("schoolId");
    const currentLoggedId = getFromLocalStorage("currentLoggedId");
    const token = JSON.parse(getFromLocalStorage("user"));
    const authorization = `Bearer ${token.accessToken}`;

    var adminRole = getFromLocalStorage("loginRole");
    const assignedRights = JSON.parse(
      getFromLocalStorage("assignedRights") || []
    );
    const assignedRightsIds = assignedRights.map((item) => item.displayName);

    // let div = this.dropRef.current;
    // this.dragCounter = 0;
    this.setState({
      currentLoggedId,
      schoolId,
      currentSchool,
      currentUserId,
      authorization,
      adminRole,
      assignedRights: assignedRightsIds,
    });
    // div.addEventListener("dragenter", this.handleDragIn);
    // div.addEventListener("dragleave", this.handleDragOut);
    // div.addEventListener("dragover", this.handleDrag);
    // div.addEventListener("drop", this.handleDrop);
  }

  componentWillUnmount() {
    const { resetUploadVideoInitialState, resetVideoScheduleEventData } =
      this.props;
    resetUploadVideoInitialState({
      status: true,
    });
    resetVideoScheduleEventData([
      "uploadvideoEvent",
      "uploadVideoWeek",
      "uploadVideoWeekName",
      "uploadVideoEventType",
      "uploadVideoOffSeasonEventName",
      "otherEventName",
      "practice",
      "opponentName",
    ]);
    let div = this.dropRef.current;
  }

  closeSaveDialog() {
    this.setState({
      opensaveDialog: !this.state.opensaveDialog,
      category: "",
      eventId: "",
      playlistId: "",
    });
  }

  openremoveDialog() {
    this.setState({ removeDialog: !this.state.removeDialog });
  }

  closeremoveDialog() {
    this.setState({ removeDialog: !this.state.removeDialog });
  }

  openDialogForCancel() {
    this.setState({ openCancel: !this.state.openCancel });
  }
  closeDialogForCancel() {
    this.setState({ openCancel: !this.state.openCancel });
  }

  closeaddeventsuccessDialog() {
    this.setState({ eventSuccesspopup: !this.state.eventSuccesspopup });
  }

  changeHandlerForVideoUpload(event, fromBroswe) {
    const { selectedFileData } = this.state;
    let file = fromBroswe ? event : event.target.files;
    let selectedFileDatas;
    if (selectedFileData.length < 0) {
      selectedFileDatas = [...file];
      this.setState({
        selectedFileData: selectedFileDatas,
        isSelectedVideo: !this.state.isSelectedVideo,
      });
    } else {
      selectedFileDatas = [...this.state.selectedFileData, ...file];
      this.setState({
        selectedFileData: selectedFileDatas,
        isSelectedVideo: !this.state.isSelectedVideo,
      });
    }
  }

  changeHandlerForVideoUploadAdd(event) {
    let file = event.target.files;
    const expand = [...file];
    let selectedFileData = [...this.state.selectedFileData, ...file];
    this.setState({ selectedFileData });
  }

  customUploadProgress = (fileName) => (progress) => {
    let percentage = Math.floor((progress.loaded * 100) / progress.total);
    const { fileStatus } = this.state;
    const findIndex = fileStatus.findIndex((ele) => ele.name === fileName);
    let update = [];
    if (findIndex === -1) {
      update = [...fileStatus, { name: fileName, value: percentage }];
    } else {
      const tempArr = [...fileStatus];
      tempArr[findIndex].value = percentage;
      tempArr[findIndex].name = fileName;
      update = tempArr;
    }
    this.setState({
      fileStatus: update,
    });
  };

  handleApiCallWithRetry = async (apiCall, params) => {
    const MAX_RETRY_ATTEMPTS = 3; // Maximum number of retry attempts
    let attempt = 1;
    let success = false;
    while (!success && attempt <= MAX_RETRY_ATTEMPTS) {
      try {
        const response = await apiCall(params[0], params[1]);
        success = true;
        return response;
      } catch (error) {
        attempt++;
      }
    }
    throw new Error(
      `Failed to complete API call after ${MAX_RETRY_ATTEMPTS} attempts`
    );
  };

  handleSubmissionForVideoUpload = async () => {
    this.toggleDeleteDialog();
    const { setFailPopUpInformation } = this.props;
    try {
      const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB chunk size
      this.setState({
        isFileUploading: true,
        isSelectedVideo: true,
        loading: true,
      });
      const { selectedFileData } = this.state;
      this.isSelectedVideo = true;
      this.uploadingFileTotalLength = selectedFileData.length;
      let user = JSON.parse(getFromLocalStorage("user"));
      this.setState({ uploadVideoCountToShow: selectedFileData.length });
      const output = [];
      // Calculate the total size of all videos being uploaded
      let totalSize = 0;
      selectedFileData.forEach((file) => {
        totalSize += file.size;
      });
      // Initialize variables to keep track of total uploaded bytes and total chunks
      let uploadedBytes = 0;
      let totalChunksUploaded = 0;

      //For each file
      for (let i = 0; i < selectedFileData.length; i++) {
        const uploadPromises = [];
        //number of file chunk
        const totalChunks = Math.ceil(selectedFileData[i].size / CHUNK_SIZE);
        const fileNameForURL =
          Date.now().toString() + "_" + selectedFileData[i].name;
        const fileSize = convertSize(selectedFileData[i].size, "MB");
        // Initiate multipart upload
        const requestBody = {
          fileName: selectedFileData[i]?.name,
          schoolName: user?.school?.schoolName,
          schoolId: user?.school?.id,
          fileNameForURL: fileNameForURL,
          fileSize: fileSize,
        };
        //Get initiate id
        const initiateUploadRes = await this.handleApiCallWithRetry(
          userService.initiateUpload,
          [requestBody]
        );
        let uploadId = initiateUploadRes?.data?.data?.uploadId;
        // Send file chunks
        let start = 0,
          end;
        for (let j = 0; j < totalChunks; j++) {
          end = start + CHUNK_SIZE;
          const chunk = selectedFileData[i].slice(start, end);
          const formData = new FormData();

          const formDataEntries = {
            index: j,
            totalChunks: totalChunks,
            fileName: selectedFileData[i]?.name,
            schoolName: user?.school?.schoolName,
            schoolId: user?.school?.id,
            file: chunk,
            uploadId: uploadId,
            fileNameForURL: fileNameForURL,
          };

          for (const [key, value] of Object.entries(formDataEntries)) {
            formData.append(key, value);
          }

          //Upload the video in chunk
          let uploadPromise;
          let overallProgress;
          if (selectedFileData.length == 1) {
            this.setState({ uploadPercentage: 15 });
            uploadPromise = userService.uploadChunk(formData);
            // Update the total uploaded bytes with the size of the current chunk
            uploadedBytes += chunk.size;

            // Calculate the overall progress across all videos
            overallProgress = Math.round((uploadedBytes / totalSize) * 38);
          } else {
            uploadPromise = userService.uploadChunk(formData);
            // Update the total uploaded bytes with the size of the current chunk
            uploadedBytes += chunk.size;

            // Calculate the overall progress across all videos
            overallProgress = Math.round((uploadedBytes / totalSize) * 90);
          }

          // Update the state with the overall progress
          this.setState({ uploadPercentage: overallProgress });

          totalChunksUploaded++;
          uploadPromises.push(uploadPromise);
          start = end;
        }
        let settledPromises = await Promise.allSettled(uploadPromises);
        // Filter out the failed promises
        let failedPromises = settledPromises
          .filter((result) => result.status === "rejected")
          .map((result) => result.reason);

        if (failedPromises.length != 0) {
          for (let k = 0; k < failedPromises.length; k++) {
            let retryAttempts = 0;
            while (retryAttempts < 3) {
              try {
                await userService.uploadChunk(failedPromises[k].config.data);
                break; // Exit the loop if upload is successful
              } catch (error) {
                retryAttempts++;
                if (retryAttempts === 3) {
                  throw new Error(
                    "Maximum retry attempts reached for chunk upload."
                  );
                }
              }
            }
          }
        }
        // Complete single file upload
        const response = await this.handleApiCallWithRetry(
          userService.completeUpload,
          [requestBody, uploadId]
        );
        output.push(response?.data?.data);
      }

      // Complete multipart upload
      const res = await userService.uploadS3File(output);
      this.setState({ uploadPercentage: 100 });
      res.status == 200
        ? this.setState({ uploaded: true })
        : this.setState({ uploaded: false });
      this.fileAddress = res?.data?.data?.filePath;
      let allVideoDuration = [];
      const fileSize = res?.data?.data?.fileSize;
      for (var i = 0; i < res?.data?.data?.length; i++) {
        allVideoDuration.push(res?.data?.data[i]?.videoDuration);
      }
      const sum = allVideoDuration.reduce((partialSum, a) => partialSum + a, 0);
      this.fileId = res.data.data.id;
      let uploadedVideoData = [];
      uploadedVideoData = res?.data?.data;
      this.getKeys(uploadedVideoData);
      this.setState({
        uploadedVideoData: [...this.state.uploadedVideoData, ...res.data.data],
        mediaFileArr: [...this.state.mediaFileArr, ...res.data.data],
        saveDisable: true,
        fileSize,
        videoDuration: sum,
        loading: false,
      });
      this.props.setVideoList(res?.data?.data);
    } catch (error) {
      setFailPopUpInformation({
        open: true,
        message: "Something Went Wrong",
      });
    }
  };

  // handleSubmissionForVideoUpload = () => {
  //   this.setState({
  //     isFileUploading: true,
  //     isSelectedVideo: true,
  //     loading: true,
  //   });
  //   const { selectedFileData, currentUserId } = this.state;
  //   const { setFailPopUpInformation } = this.props;
  //   this.isSelectedVideo = true;
  //   this.uploadingFileTotalLength = selectedFileData.length;
  //   let token = JSON.parse(getFromLocalStorage("user"));

  //   const axiosInstance = axios.create({
  //     baseURL: "https://devapi.contendzone.com/ContendZONE/api",
  //   });

  //   this.setState({ uploadVideoCountToShow: selectedFileData.length });
  //   const data = new FormData();
  //   data.append("userId", currentUserId);
  //   for (let i = 0; i < selectedFileData.length; i++) {
  //     data.append("file", selectedFileData[i]);
  //     data.append("fileSize", convertSize(selectedFileData[i].size, "MB"));
  //   }

  //   axiosInstance
  //     .post("/file/uploadFile", data, {
  //       onUploadProgress: (data) => {
  //         this.setState({
  //           uploadPercentage: Math.round((data.loaded / data.total) * 100),
  //         });
  //       },
  //       headers: {
  //         Authorization: "Bearer " + token.accessToken,
  //         "Content-type": "multipart/form-data",
  //       },
  //     })
  //     .then((res) => {
  //       res.status == 200
  //         ? this.setState({ uploaded: true })
  //         : this.setState({ uploaded: false });
  //       this.fileAddress = res.data.data.filePath;
  //       let allVideoDuration = [];
  //       const fileSize = res.data.data.fileSize;
  //       for (var i = 0; i < res.data.data.length; i++) {
  //         allVideoDuration.push(res.data.data[i].videoDuration);
  //       }
  //       const sum = allVideoDuration.reduce(
  //         (partialSum, a) => partialSum + a,
  //         0
  //       );
  //       this.fileId = res.data.data.id;
  //       let uploadedVideoData = [];
  //       uploadedVideoData = res.data.data;
  //       this.getKeys(uploadedVideoData);
  //       this.setState({
  //         uploadedVideoData: [
  //           ...this.state.uploadedVideoData,
  //           ...res.data.data,
  //         ],
  //         mediaFileArr: [...this.state.mediaFileArr, ...res.data.data],
  //         saveDisable: true,
  //         fileSize,
  //         videoDuration: sum,
  //         loading: false,
  //       });
  //       this.props.setVideoList(res.data.data);
  //     })
  //     .catch(() => {
  //       setFailPopUpInformation({
  //         open: true,
  //         message: "Something Went Wrong",
  //       });
  //     });
  // };

  getKeys(VideoData) {
    let UploadedVideoKeys = [];
    for (var i = 0; i < VideoData.length; i++) {
      const fileKey = VideoData[i].filePath;
      const key = /[^/]*$/.exec(fileKey)[0];
      const replacedString = key.replace(/%2F/g, "/");
      UploadedVideoKeys.push(replacedString);
    }
    this.setState({ UploadedVideoKeys });
  }

  cancelUpload = () => {
    const { currentUserId, authorization, UploadedVideoKeys } = this.state;
    const { setFailPopUpInformation } = this.props;
    userService
      .deleteUploadedFile(UploadedVideoKeys, currentUserId, authorization)
      .then((res) => {
        var data = res.data;
        if (data.success === true) {
          this.setState({
            openCancel: false,
            isFileUploading: false,
            deletePopUp: false,
            uploadedVideoData: [],
            mediaFileArr: [],
            uploadPercentage: null,
            hideSelectedFiles: true,
            isSelectedVideo: false,
            selectedFileData: [],
          });
        }
      })
      .catch(() => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  handleselectedFileChange(event) {
    this.setState({
      file: URL.createObjectURL(event.target.files[0]),
    });
  }

  handleRemove = (event, index) => {
    const { selectedFileData, fileStatus } = this.state;
    selectedFileData.splice(index, 1);
    let selectedFiles = [...selectedFileData];

    const updatedFileStatus = [...fileStatus];
    this.setState(
      {
        selectedFileData: selectedFiles,
        fileStatus: updatedFileStatus.splice(index, 1),
      },
      () => {
        if (selectedFileData.length === 0) {
          this.setState({ isSelectedVideo: false });
        }
      }
    );
  };

  truncateString(string) {
    if (string.length > 25) {
      return string.substring(0, 25) + ". . .";
    } else {
      return string;
    }
  }

  removeuploadedVideo(fileKey, index) {
    const { uploadedVideoList } = this.props;
    const { currentUserId, authorization, uploadVideoCountToShow } = this.state;
    if (uploadedVideoList.length > 1) {
      this.setState({ selectedFileKey: fileKey, selectedFileIndex: index });
      this.props.setConfirmationPopupInformation({
        confirmationPopup: {
          open: true,
          message: "Are You Sure, You Want To Cancel?",
          btnColor: "red",
          btnText: "Yes",
          type: "Remove Uploaded Video From Upload Video Page",
          currentUserId,
          authorization,
          uploadVideoCountToShow,
          selectedFileKey: fileKey,
          selectedFileIndex: index,
        },
      });
    } else {
      this.openDialogForCancel();
    }
  }

  renderDataUploadDone = () => {
    const { loading } = this.state;
    const {
      uploadedVideoList,
      setSuccessPopupInformation,
      setVideoPopUpInformation,
      setRenamePopupInformation,
    } = this.props;
    return (
      <>
        {uploadedVideoList &&
          uploadedVideoList.map((item, index) => (
            <div
              className="uploaded-video-main-container mg-top-20"
              key={index}
            >
              <div className="video-thumbnail-and-video-text-container">
                <div className="d-flex-align-cent">
                  <video src={item.filePath} className="video-thumbnail" />
                </div>
                <div className="w-100 padding-5 oflow-hidden d-flex-align-cent white">
                  <p className="text-width-auto">{item.fileName}</p>
                </div>
              </div>
              <div className="upload-video-preview-btn-container">
                <div className="d-flex-align-cent gap-10">
                  <button
                    className="video-preview-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setVideoPopUpInformation({
                        status: true,
                        videoURL: item.filePath,
                      });
                    }}
                  >
                    {" "}
                    <img src={preview} alt="" className="pr-2" />
                    Preview
                  </button>

                  <button
                    className="video-preview-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setRenamePopupInformation({
                        renamePopup: {
                          open: true,
                          videoData: item,
                          fieldToShow: "fileName",
                          type: "rename-video-from-upload-video-page",
                        },
                      });
                    }}
                  >
                    Rename
                  </button>

                  <button
                    className="video-preview-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSuccessPopupInformation({
                        successPopUp: {
                          message: "Work In Progress",
                          open: true,
                        },
                      });
                    }}
                  >
                    Play Cards
                  </button>

                  <button
                    className="video-remove-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.removeuploadedVideo(item.filePath, index);
                    }}
                  >
                    <span className="mg-right-10">
                      <FaTrash />
                    </span>
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        {loading && (
          <div className="d-flex-center mg-top-20">
            <CircularProgress sx={{ fontSize: 10, color: "#002244" }} />
          </div>
        )}
      </>
    );
  };

  renderDataUpload = () => {
    const { fileStatus } = this.state;
    return fileStatus.map(({ name, value }, index) => (
      <div key={index} className="row pt-20 pb-10 video-que">
        <p className="file-nm">{this.truncateString(name)}</p>
        <button className="video-remove-btn">
          <span className="mg-right-10">
            <FaTrash />
          </span>
          Remove
        </button>
        <div className="col-md-12 col-lg-12 plr">
          <div className="mg-top-10 mg-bottom-10">
            <ProgressBar now={value} />
          </div>
        </div>
      </div>
    ));
  };

  renderData = () => {
    const { selectedFileData } = this.state;
    return selectedFileData.map((item, index) => (
      <div key={index} className="row pt-20 pb-20 video-que">
        <p className="white file-nm">{this.truncateString(item.name)}</p>
        <button
          className="video-remove-btn"
          onClick={(event) => this.handleRemove(event, index)}
        >
          <span className="mg-right-10">
            <FaTrash />
          </span>
          Remove
        </button>
      </div>
    ));
  };

  toggleDeleteDialog = () => {
    const { deletePopUp } = this.state;
    this.setState({
      deletePopUp: !deletePopUp,
    });
  };

  toggleSuccessDialog = () => {
    const { eventSuccesspopup, uploadedVideoData } = this.state;
    if (uploadedVideoData.length == 0) {
      this.setState({ redirect: true });
    }
    this.setState({ eventSuccesspopup: !eventSuccesspopup });
  };

  UploadConfirmationDialog = () => {
    const { deletePopUp } = this.state;
    return (
      <Dialog
        id="dialogBoxRemove"
        className="dialog-stylee"
        open={deletePopUp}
        onClose={this.toggleDeleteDialog}
      >
        <DialogTitle>
          <div className="row">
            <div className="col-1 text-right ml-auto">
              <FaTimes
                onClick={(event) => {
                  event.stopPropagation();
                  this.toggleDeleteDialog();
                }}
                className="crossview cp"
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="clear10"></div>
          <div className="row">
            <div className="col-12 text-center">
              <p className="fs-20 semi-bold text-center mb-4">
                Are you sure, you want to Upload all selected videos?
              </p>
            </div>
            <div className="d-flex-space-between mg-auto">
              <button
                type="button"
                class="cancelbtn canBtn mg-right-20"
                onClick={(event) => {
                  event.stopPropagation();
                  this.toggleDeleteDialog();
                }}
              >
                No
              </button>

              <button
                type="button"
                class="green-btn"
                onClick={() => this.handleSubmissionForVideoUpload()}
              >
                Yes, Upload
              </button>
            </div>
          </div>
          <div className="clear10"></div>
          <div className="clear10"></div>
        </DialogContent>
      </Dialog>
    );
  };

  saveUploadedVideo = ({
    uploadvideoEvent,
    uploadVideoWeek,
    uploadVideoWeekName,
    uploadVideoEventType,
    uploadVideoOffSeasonEventName,
    otherEventName,
    practice,
    playlistName,
  }) => {
    const {
      uploadedVideoList,
      currentSeason,
      setFailPopUpInformation,
      videoScheduleInformation,
    } = this.props;
    const playListId = videoScheduleInformation?.playlistData?.filter(
      (ele) => playlistName == ele?.playlistName
    )[0]?.id;
    userService
      .saveScheduleEvent(
        uploadVideoEventType,
        this.state.schoolId,
        uploadvideoEvent === "Off-Season"
          ? uploadVideoOffSeasonEventName
          : otherEventName,
        practice,
        uploadedVideoList,
        uploadvideoEvent,
        uploadVideoWeek,
        uploadvideoEvent === "Off-Season" ? true : false,
        currentSeason.id,
        false,
        playListId
      )
      .then((res) => {
        this.setState({
          opensaveDialog: true,
          scheduleEventType: uploadvideoEvent,
          offSeasonEventName: uploadVideoOffSeasonEventName,
          practiceName: practice,
          otherEventType: otherEventName,
          weekName: uploadVideoWeekName,
          eventCategory: uploadVideoEventType,
        });
      })
      .catch((err) => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  toggleConfirmationDialog = (status) => {
    this.setState({ confirmationPopup: status });
  };

  handleNavigation = () => {
    const {
      scheduleEventType,
      seasonId,
      otherEventType,
      offSeasonEventName,
      practiceName,
      weekName,
      eventCategory,
    } = this.state;
    const { history } = this.props;
    switch (scheduleEventType) {
      case "Other":
        history.push(
          `/videoplayer?season-year=${seasonId}&season-type=${scheduleEventType}&event-type=${otherEventType}`
        );
        break;

      case "Off-Season":
        history.push(
          `/videoplayer?season-year=${seasonId}&season-type=${scheduleEventType}&eventname=${offSeasonEventName}&practice=${practiceName}`
        );
        break;

      case "In-Season":
        history.push(
          `/videoplayer?season-year=${seasonId}&season-type=${scheduleEventType}&week=${weekName}&event-type=${eventCategory}`
        );
        break;

      default:
        break;
    }
  };

  render() {
    const {
      isSelectedVideo,
      totalData,
      isFileUploading,
      fileStatus,
      submitting,
      redirect,
      selectedFileData,
      opensaveDialog,
      openCancel,
      assignedRights,
      adminRole,
      redirectToVideoEdits,
      uploadPercentage,
      scheduleEventType,
      seasonId,
      offSeasonEventName,
      practiceName,
      otherEventType,
      weekName,
      eventCategory,
    } = this.state;

    const {
      currentSeason,
      uploadedVideoList,
      videoScheduleInformation,
      isDrawerOpen,
    } = this.props;

    if (redirect == true) {
      return <Redirect to="/videolibrary" />;
    }
    if (redirectToVideoEdits) {
      return (
        <Redirect
          to={`/videoPlayer?seasonId=${seasonId}&eventId=${scheduleEventType}&weekId=${weekName}&eventCategory=${eventCategory}&off-season-eventName=${offSeasonEventName}&practice=${practiceName}&otherEventType=${otherEventType}`}
        />
      );
    }
    return (
      <>
        {(adminRole == "SCHOOL ADMIN" ||
          assignedRights.includes("Add / Remove Video Content")) &&
        currentSeason ? (
          <>
            <SchoolAdminDashboard />
            <div
              // className="content-layout"
              className={
                isDrawerOpen
                  ? "content-layout p-0"
                  : "toggle-content-layout p-0"
              }
            >
              <div className="video-upload">
                <div>
                  {!isSelectedVideo && (
                    <div className="margin-auto ">
                      <section className="video-section">
                        <div className="row video-container w-100">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 w-100">
                            <div className="row w-100 bg-danger ">
                              <div className=" col-12 col-sm-12 col-md-6 col-lg-6 mt-30 ">
                                <div className="uploadDocuments-card">
                                  <div className="row">
                                    <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                      <img src={videoCamera} alt="Video" />
                                      <label className="ml-2 bold fs-16">
                                        Videos Upload
                                      </label>
                                    </div>
                                  </div>
                                  <div className="clear10"></div>

                                  <div
                                    className="uploadDoc-innercard text-center "
                                    ref={this.dropRef}
                                  >
                                    <div className="mRL">
                                      <label
                                        htmlFor="upload-photo-1"
                                        className="addBtnn2 cp selectFileBtn"
                                      >
                                        Select Video Files
                                      </label>
                                      <input
                                        type="file"
                                        name="photo"
                                        id="upload-photo-1"
                                        className="selectFileBtn mobilehide"
                                        multiple
                                        onChange={
                                          this.changeHandlerForVideoUpload
                                        }
                                        accept="video/mp4, video/mov, video/avi"
                                      />

                                      <div className="clear20"></div>

                                      <label className="bold fs-16">
                                        or drag & drop the video here to upload
                                      </label>
                                      <div className="clear10"></div>
                                      <p className="txtgrey50 medium fs-16 ">
                                        You can only upload .mp4 video files.
                                        Multiple files can be <br />
                                        selected at once.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-sm-12 col-md-6 col-lg-6  mt-30">
                                <div class="instructionbox border ">
                                  <h1 className="fs-20 instruct_txt">
                                    Instructions
                                  </h1>
                                  <div className="clear20"></div>
                                  <p className="instruct_para">
                                    If the videos are from different camera
                                    angles then please name the video files as
                                    per the angle name. This will help the
                                    system to group the videos in respective
                                    angle sets and easy for School Admin and
                                    Coaches to identify.
                                  </p>
                                  <div className="clear30"></div>
                                  <p className="instruct_para">
                                    For example, the naming of video files
                                    coming from
                                    <span className="red"> five</span> camera
                                    angles -{" "}
                                    <span className="red">
                                      End Zone L, End Zone R, Wide Angle, Tight,
                                      Other - Should be as below
                                    </span>
                                  </p>
                                  <div className="clear30"></div>
                                  <ul className="instruct_paralist">
                                    <li className="camlist">EndZoneL.mp4</li>
                                    <li className="camlist">EndZoneR.mp4</li>
                                    <li className="camlist">WideAngle.mp4</li>
                                    <li className="camlist">Tight.mp4</li>
                                    <li className="camlist">Other.mp4</li>
                                  </ul>
                                  <div className="clear30"></div>
                                  <p className="instruct_para">
                                    Any video file not given one of the five
                                    above listed formats will be placed into the
                                    pending category and must be designated one
                                    of the five formats before being added to
                                    the playlist.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mg-top-20">
                          <div className="footer text-center">
                            <label className="fs-16">
                              <span className="txtblue semi-bold ">
                                {emailAddress}
                              </span>
                              <span className="medium">or</span>{" "}
                              <span className="txtblue semi-bold ">
                                {phoneNumber}
                              </span>{" "}
                            </label>
                          </div>
                        </div>
                      </section>
                    </div>
                  )}
                  {isSelectedVideo && uploadPercentage == null && (
                    <div className="w-100 padding-20">
                      <div className="uploadDocuments-card p-20">
                        <div className="ml-2 bold mg-bottom-15 d-flex-space-between gap-10">
                          <label className="bold fs-22 selected-files-count">
                            {" "}
                            {selectedFileData.length} files selected
                          </label>

                          <button
                            className="semi-bold uploadFilesBtn"
                            onClick={(event) => {
                              event.stopPropagation();
                              this.toggleDeleteDialog();
                            }}
                          >
                            <img src={updownload} className="mr-2" alt="" />
                            Start Uploading
                          </button>

                          {uploadPercentage !== 100 ? (
                            <div className="oflow-hidden">
                              <label
                                htmlFor="upload-photo-1"
                                className="addBtnn2 cp txt-center"
                              >
                                <AddIcon className="mx-1 addIconSc " />
                                Add More Videos
                              </label>
                              <input
                                type="file"
                                name="photo"
                                id="upload-photo-1"
                                className="selectFileBtn hidden"
                                multiple
                                onChange={this.changeHandlerForVideoUploadAdd}
                                accept="video/mp4,video/x-m4v,video/*"
                              />
                            </div>
                          ) : null}
                        </div>
                        <div></div>

                        <div className="row bg-20">
                          <div className="col-12 brderbtm Video-upload-que-contaier">
                            {this.renderData()}
                            {this.UploadConfirmationDialog()}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {isFileUploading && (
                    <div className="margin-auto mt-15">
                      <section className="contact-section uploaded-video-container">
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="grid"></div>
                            <div className="row upload-progress">
                              <div className="col-sm-12 col-12 col-md-8 col-lg-8 d-flex justify-content-between px-2">
                                {uploadPercentage < 100 && (
                                  <div className="d-flex plr">
                                    <img
                                      width="15px"
                                      height="15px"
                                      className="mt-2"
                                      src={upArrow}
                                      alt="Video"
                                    />
                                    <label className="ml-2 fs-20 bold">
                                      Upload In Progress
                                    </label>
                                  </div>
                                )}
                                {uploadPercentage === 100 && (
                                  <div className="col-5 col-sm-5 col-md-5 col-lg-5">
                                    <label className="ml-2 fs-20 bold ">
                                      Video Uploaded
                                    </label>
                                  </div>
                                )}
                              </div>
                              <div className="col-sm-12 col-12 col-md-8 col-lg-8 p-10">
                                <div className="uploadDocuments-card2">
                                  <div className="row progressHeader d-flex-space-between">
                                    {uploadPercentage < 100 && (
                                      <div className="">
                                        <label className="ml-2 semi-bold fs-18 fmlabel">
                                          {`${uploadPercentage}%`} …{" "}
                                          {Math.floor(
                                            (this.uploadingFileTotalLength *
                                              uploadPercentage) /
                                              100
                                          )}{" "}
                                          of {this.uploadingFileTotalLength}{" "}
                                          files uploaded
                                        </label>
                                        <div className="ml-2 bold fs-18 ">
                                          {totalData}
                                        </div>
                                      </div>
                                    )}
                                    {uploadPercentage === 100 &&
                                      !this.state.loading && (
                                        <div
                                          className="d-flex-space-between"
                                          style={{ width: "100%" }}
                                        >
                                          <div>
                                            <img
                                              className="hw30"
                                              src={successIcon}
                                              alt=""
                                            />
                                            <label className="lightGreen semi-bold fs-18 ml-14 upload-success">
                                              {uploadedVideoList.length}{" "}
                                              Video(s) Uploaded Successfully
                                            </label>
                                          </div>
                                          <button
                                            className="video-remove-btn brd-red"
                                            onClick={this.openDialogForCancel.bind(
                                              this
                                            )}
                                          >
                                            Cancel Upload
                                          </button>
                                        </div>
                                      )}
                                    <div>
                                      {isFileUploading == false ? (
                                        <div>
                                          <label
                                            htmlFor="upload-photo"
                                            className="addBtnn2 cp"
                                          >
                                            <AddIcon className="mx-1 addIconSc " />
                                            Add More Videos
                                          </label>
                                          <input
                                            type="file"
                                            name="photo"
                                            id="upload-photo"
                                            className="selectFileBtn"
                                            multiple
                                            onChange={
                                              this
                                                .changeHandlerForVideoUploadAdd
                                            }
                                            accept="video/mp4,video/x-m4v,video/*"
                                          />
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                  {
                                    <div className="progress mt-2 progress-lg">
                                      <div
                                        className="progress-bar"
                                        role="progressbar"
                                        areavaluenow={uploadPercentage}
                                        areavaluemin="0"
                                        areavaluemax="100"
                                        style={{
                                          width: `${uploadPercentage}%`,
                                        }}
                                      >
                                        <p>{`${uploadPercentage}%`}</p>
                                      </div>
                                    </div>
                                  }
                                  {uploadPercentage < 100 && (
                                    <div className="height-350 overflox-y overflow-x-none">
                                      {this.renderDataUpload()}
                                    </div>
                                  )}

                                  {uploadPercentage === 100 ? (
                                    <div className="height-350 overflox-y overflow-x-none">
                                      {this.renderDataUploadDone()}
                                    </div>
                                  ) : null}
                                </div>
                              </div>

                              <div className="clear20"></div>
                              {submitting && (
                                <CircularProgress
                                  className="circle-mark"
                                  color="secondary"
                                />
                              )}

                              <div className=" col-sm-12 col-md-4 col-lg-4 p-10">
                                <div className="uploadDocuments-card2">
                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <Formik
                                        initialValues={{
                                          uploadvideoEvent:
                                            videoScheduleInformation?.uploadvideoEvent,
                                          uploadVideoWeek:
                                            videoScheduleInformation?.uploadVideoWeek,
                                          uploadVideoWeekName:
                                            videoScheduleInformation?.uploadVideoWeekName,
                                          uploadVideoEventType:
                                            videoScheduleInformation?.uploadVideoEventType,
                                          uploadVideoOffSeasonEventName:
                                            videoScheduleInformation?.uploadVideoOffSeasonEventName,
                                          otherEventName:
                                            videoScheduleInformation?.otherEventName,
                                          practice:
                                            videoScheduleInformation?.practice,
                                          playlistName:
                                            videoScheduleInformation?.uploadPlaylistName,
                                        }}
                                        validationSchema={
                                          validationSchema.UploadVideoSchema
                                        }
                                        enableReinitialize
                                        onSubmit={(
                                          values,
                                          { setSubmitting }
                                        ) => {
                                          setSubmitting(true);
                                          this.saveUploadedVideo(values);
                                          setSubmitting(false);
                                        }}
                                      >
                                        {(formik) => (
                                          <Form>
                                            <p className="fs-20 bold">
                                              {`${currentSeason.years} Season`}
                                            </p>
                                            <UploadVideoForm formik={formik} />
                                            <button
                                              type="submit"
                                              className={
                                                formik.isValid &&
                                                uploadPercentage === 100
                                                  ? "saveBtn1"
                                                  : "saveBtn1 activv"
                                              }
                                              disabled={
                                                !formik.isValid ||
                                                uploadPercentage !== 100
                                              }
                                            >
                                              Save
                                            </button>
                                          </Form>
                                        )}
                                      </Formik>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <Dialog
                                        id="savedialogBox"
                                        className="dialog-style"
                                        open={opensaveDialog}
                                        onClose={this.closeSaveDialog.bind(
                                          this
                                        )}
                                      >
                                        <DialogTitle>
                                          <div className="row">
                                            <div className="col-12 text-center">
                                              <div className="bold fs-20">
                                                Videos Saved to Library
                                              </div>
                                            </div>
                                          </div>
                                        </DialogTitle>
                                        <DialogContent>
                                          <div className="row">
                                            <div className="col-12 text-center">
                                              <label
                                                className="bggrey fs-16 medium cp"
                                                onClick={() =>
                                                  this.handleNavigation()
                                                }
                                              >
                                                View the playlist in library
                                              </label>
                                            </div>
                                          </div>
                                          <div className="clear10"></div>
                                        </DialogContent>
                                      </Dialog>

                                      <Dialog
                                        id="dialogBox5"
                                        className="dialog-style upload-modal"
                                        open={openCancel}
                                        onClose={this.closeDialogForCancel.bind(
                                          this
                                        )}
                                      >
                                        <DialogTitle>
                                          <div className="row">
                                            <div className="col-1 text-right ml-auto mr-4">
                                              <BsXLg
                                                onClick={this.closeDialogForCancel.bind(
                                                  this
                                                )}
                                                className="crossview cp"
                                              ></BsXLg>
                                            </div>
                                          </div>
                                        </DialogTitle>
                                        <DialogContent>
                                          <div className="clear10"></div>
                                          <div className="row">
                                            <div className="col-12 text-center">
                                              <p className="fs-20 semi-bold text-center">
                                                You have not saved the Playlist.
                                                Navigating away or closing the
                                                page will cancel the Upload
                                                activity. Are you sure?
                                              </p>
                                              <div className="clear10"></div>
                                            </div>
                                            <div className="col-12 col-md-12 col-lg-12">
                                              <div className="d-flex justify-content-center">
                                                <div className="">
                                                  <button
                                                    type="button"
                                                    class="cancelbtn canBtn"
                                                    onClick={this.closeDialogForCancel.bind(
                                                      this
                                                    )}
                                                  >
                                                    No
                                                  </button>
                                                </div>
                                                <div className="ml-3">
                                                  <button
                                                    type="button"
                                                    class="green-btn"
                                                    onClick={() =>
                                                      this.cancelUpload()
                                                    }
                                                  >
                                                    Yes, Cancel
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="clear10"></div>

                                          <div className="clear10"></div>
                                        </DialogContent>
                                      </Dialog>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  )}
                  {fileStatus.map(({ name, value }) => (
                    <div key={value}>
                      <p className="dnone">
                        file name {name} and file name {value}%
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setVideoList: (obj) => setUploadedVideoList(dispatch, obj),
    setConfirmationPopupInformation: (obj) =>
      openConfirmationPopup(dispatch, obj),
    setRenamePopupInformation: (obj) => openRenamePopup(dispatch, obj),
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
    setVideoPopUpInformation: (obj) => openVideoPopup(dispatch, obj),
    resetUploadVideoInitialState: (obj) =>
      resetUploadVideoInitialState(dispatch, obj),
    resetVideoScheduleEventData: (obj) =>
      resetVideoScheduleEventData(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return {
    currentSeason: state.loggedInUser.userProfile.currentSeason,
    uploadedVideoList: state.uploadVideoData.uploadedVideoList,
    videoScheduleInformation: state?.videoScheduleInformation,
    isDrawerOpen: state?.schoolAdminDashboardInformation.isDrawerOpen,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(uploadVideo)
);
